import InfoPanel from './InformationPanel-infoPanel-config.json';
import StatusScreens from './StatusScreenOverlays-statusScreens-config.json';
import LivePoll from './LivePoll-livePoll-config.json';
import Wave from './TwitchWave-twitchWave-config.json';
import ImageOverlay from './ImageOverlay-imageOverlay-config.json';
import ImageOverlaySimple from './ImageOverlaySimple-imageOverlay-config.json';
import FlockToUnlock from './FlocktoUnlock-flockToUnlock-config.json';
import ObjectZapper from './ObjectZapper-objectZapper-config.json';
import ObjectSpawner from './ObjectSpawner-objectSpawner-config.json';
import SlidePuzzle from './SlidePuzzle-slide-puzzle-config.json';
import Leaderboards from './Leaderboards-leaderboard-config.json';
import LiveText from './LiveText-liveText-config.json';
import FireworksParticlesEffect from './Fireworks-particleEffects-config.json';
import ConfettiParticlesEffect from './Confetti-particleEffects-config.json';
import CombinedParticleEffects from './_SKIP_CombinedParticleEffects-particleEffects-config.json'
import VideoDisruptor from './VideoDisruptor-disruptorVideo-config.json';
import LiveTrivia from './LiveTrivia-liveTrivia-config.json';
import Countdown321 from './Countdown321-countdown321-config.json';
import SlotsRandomizer from './Slots-randomiser-config.json';
import SubBombCounter from './SubBombCounter-subBomb-config.json';
import AudioDisruptor from './AudioDisruptor-disruptorAudio-config.json';
import AnimatedOverlay from './AnimatedOverlay-animatedOverlay-config.json';

// The list of disruptors is built taking into account variations in visual editor config setups.
// This allows us to have multiple disruptors with different config setups, eg. Confetti and Fireworks are both particle effects,
// some settings are fixed (the type) and some settings that are not relevant are removed from the config.
// If a config isn't found for a disruptor the legacy customisation style is used.
export const WorkspaceConfig = {
    infoPanel: InfoPanel,
    statusScreens: StatusScreens,
    livePoll: LivePoll,
    liveTrivia: LiveTrivia,
    twitchWave: Wave,
    imageOverlay: ImageOverlay,
    imageOverlay_simple: ImageOverlaySimple,
    flockToUnlock: FlockToUnlock,
    objectZapper: ObjectZapper,
    objectSpawner: ObjectSpawner,
    "slide-puzzle": SlidePuzzle,
    leaderboard: Leaderboards,
    liveText: LiveText,
    // Multiple variations of particle effects
    // particleEffects: CombinedParticleEffects,
    particleEffects_fireworks: FireworksParticlesEffect,
    particleEffects_confetti: ConfettiParticlesEffect,
    disruptorVideo: VideoDisruptor,
    countdown321: Countdown321,
    // Note, for multiple configs to be picked up we must include more than one variation, we can force one to be a legacy disruptor by setting it to null, as with the randomiser below.
    randomiser: null,
    randomiser_slots: SlotsRandomizer,
    subBomb: SubBombCounter,
    disruptorAudio: AudioDisruptor,
    animatedOverlay: AnimatedOverlay,
};
